import { render, staticRenderFns } from "./HoldModel.vue?vue&type=template&id=56751c16&"
import script from "./HoldModel.vue?vue&type=script&lang=js&"
export * from "./HoldModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports